import transformGridItems from 'redux/transforms/transform-grid-items';
import mapProductsIntoLegacyFormat from './transform-product-into-legacy-format';

const newTransformInterstitialsContent = (alldata = {}) => {
  const { content = {}, steps, componentsAndProducts } = alldata;

  const componentsAndProductsFiltered = componentsAndProducts?.map(({ product }) => ({
    ...product,
  }));

  return {
    ...transformGridItems({
      ...content,
      ...mapProductsIntoLegacyFormat({ componentsAndProducts: componentsAndProductsFiltered }),
    }),
    interstitials: {
      currentStep: steps && steps[0]?.id,
      steps,
    },
  };
};

export default newTransformInterstitialsContent;
